import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './extend-form.hbs'
import CalendarControl from 'scoreboard/components/calendar-control'
import BusyButton from 'scoreboard/components/busy-button'
import ConfirmPrompt from 'scoreboard/components/confirm-prompt'
import appDisplay from 'scoreboard/components/app-display'

var ExtendForm = Backbone.View.extend({

	// this.calendar is a plain javascript object representing the calendar

	tagName: 'form',
	className: 'extend-calendar-form',

	events: {
		'submit': 'submit'
	},

	initialize: function(options) {
		this.options = options
		this.calendar = options && options.calendar
		this.calendarControl = new CalendarControl({
			tooltip: false
		})
	},

	render: function() {
		this.$el.empty().append(template())
		this.$('.date').append(this.calendarControl.el)
		this.calendarControl.render()
		return this
	},

	submit: function(e) {
		e.preventDefault()
		this.$el.addClass('is-submitting-form') // Doesn't use formView so add class manually
		this.busyButton = new BusyButton({ el: this.$('.button-primary') }).loading()
		// #44189 open a confirm prompt to warn user that extending a calendar
		// will trigger a full score recalc
		let recalcPrompt = new ConfirmPrompt({
			titleKey: 'admin.recalcScores',
			messageKey: 'admin.recalcScoresConfirm',
			confirmLabel: 'admin.recalcScores.recalculate',
			cancelLabel: 'common.cancel',
			onConfirm: () => {
				let url = 'api/admin/calendars/' + this.calendar.id + '/extend?date='
				url += this.calendarControl.getIsoDate()
				$.ajax({
					method: 'post',
					url: url,
					success: this.trigger.bind(this, 'done')
				})
			}
		})
		recalcPrompt.once('cancel', () => this.trigger('done'))
		appDisplay.dialog(recalcPrompt)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.calendarControl, this.busyButton], 'remove')
	}

})

export default ExtendForm

ExtendForm.__filename__ = 'admin/calendars/extend-form.js'
